export default __webpack_public_path__ + "static/media/TL06.1.a6aad6e2.mp3";